import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { Posting } from '../../models/posting.model';
import { FetchAllPostings, FetchAllPostingsSuccess } from '../../actions/all-postings.action';

export class PostingsDataSource implements DataSource<Posting> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _postings$: Observable<Posting[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<Posting[]> {
        return this._postings$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadPostings(
        pageSize: number,
        pageNumber: number,
        sortBy: string,
        sortOrder: string,
        search?: string,
        postingTypeId?: number,
        languageId?: string,
        contentTypeId?: number,
        onlyValid?: boolean
    ): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchAllPostings({
                pageSize,
                pageNumber,
                sortBy,
                sortOrder,
                search,
                postingTypeId,
                languageId,
                contentTypeId,
                onlyValid,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchAllPostingsSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
